/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _redux = require('redux');

var _reduxRouter = require('redux-router');

var _ad = require('./ad');

var _ad2 = _interopRequireDefault(_ad);

var _adGroup = require('./adGroup');

var _adGroup2 = _interopRequireDefault(_adGroup);

var _about = require('./about');

var _about2 = _interopRequireDefault(_about);

var _article = require('./article');

var _article2 = _interopRequireDefault(_article);

var _articles = require('./articles');

var _articles2 = _interopRequireDefault(_articles);

var _authors = require('./authors');

var _authors2 = _interopRequireDefault(_authors);

var _categories = require('./categories');

var _categories2 = _interopRequireDefault(_categories);

var _coldBrew = require('./coldBrew');

var _coldBrew2 = _interopRequireDefault(_coldBrew);

var _contributors = require('./contributors');

var _contributors2 = _interopRequireDefault(_contributors);

var _login = require('./login');

var _login2 = _interopRequireDefault(_login);

var _moreArticles = require('./moreArticles');

var _moreArticles2 = _interopRequireDefault(_moreArticles);

var _moreNews = require('./moreNews');

var _moreNews2 = _interopRequireDefault(_moreNews);

var _mostPopular = require('./mostPopular');

var _mostPopular2 = _interopRequireDefault(_mostPopular);

var _navSections = require('./navSections');

var _navSections2 = _interopRequireDefault(_navSections);

var _navSpecialSeries = require('./navSpecialSeries');

var _navSpecialSeries2 = _interopRequireDefault(_navSpecialSeries);

var _page = require('./page');

var _page2 = _interopRequireDefault(_page);

var _recentComments = require('./recentComments');

var _recentComments2 = _interopRequireDefault(_recentComments);

var _responsive = require('./responsive');

var _responsive2 = _interopRequireDefault(_responsive);

var _search = require('./search');

var _search2 = _interopRequireDefault(_search);

var _section = require('./section');

var _section2 = _interopRequireDefault(_section);

var _specialSeries = require('./specialSeries');

var _specialSeries2 = _interopRequireDefault(_specialSeries);

var _specialSeriesCategory = require('./specialSeriesCategory');

var _specialSeriesCategory2 = _interopRequireDefault(_specialSeriesCategory);

var _specialSeriesRollup = require('./specialSeriesRollup');

var _specialSeriesRollup2 = _interopRequireDefault(_specialSeriesRollup);

var _subscribeModal = require('./subscribeModal');

var _subscribeModal2 = _interopRequireDefault(_subscribeModal);

var _theDrip = require('./theDrip');

var _theDrip2 = _interopRequireDefault(_theDrip);

exports['default'] = _redux.combineReducers({
	router: _reduxRouter.routerStateReducer,
	ad: _ad2['default'],
	adGroup: _adGroup2['default'],
	about: _about2['default'],
	article: _article2['default'],
	articles: _articles2['default'],
	authors: _authors2['default'],
	categories: _categories2['default'],
	coldBrew: _coldBrew2['default'],
	contributors: _contributors2['default'],
	login: _login2['default'],
	moreArticles: _moreArticles2['default'],
	moreNews: _moreNews2['default'],
	mostPopular: _mostPopular2['default'],
	navSections: _navSections2['default'],
	navSpecialSeries: _navSpecialSeries2['default'],
	page: _page2['default'],
	recentComments: _recentComments2['default'],
	responsive: _responsive2['default'],
	search: _search2['default'],
	section: _section2['default'],
	specialSeries: _specialSeries2['default'],
	specialSeriesCategory: _specialSeriesCategory2['default'],
	specialSeriesRollup: _specialSeriesRollup2['default'],
	subscribeModal: _subscribeModal2['default'],
	theDrip: _theDrip2['default']
});
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/reducer.js
 ** module id = 721
 ** module chunks = 0
 **/